const EMPTY_ID_FIELD_PATTERN = /(^id$|Id$|_id$)/

/**
 * Returns sorted field names on the request message whose values are empty strings
 * and whose names look like identifiers (objectId, feedId, session_id, etc.).
 */
export function findEmptyIdFields(message: unknown): string[] {
  if (!message || typeof message !== 'object') {
    return []
  }

  return Object.entries(message)
    .filter(
      ([field, value]) =>
        typeof value === 'string' && value === '' && EMPTY_ID_FIELD_PATTERN.test(field),
    )
    .map(([field]) => field)
    .sort()
}
